import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { get, isNil } from 'lodash'

import { backendDocType, namespace } from './config'
import { CRUDO } from '../TicketHelper'
import { TicketState } from '@common'
import { cceClient } from '@gql'

import { _queryProduct } from './ticket.gql'

export function useScopeName(scope_id) {
  const { loading, data } = useQuery(_queryProduct, {
    client: cceClient,
    variables: {
      doc_ids: [scope_id],
    },
  })

  return useMemo(
    () =>
      loading || isNil(data) ? scope_id : get(data, 'queryProduct.0.title'),
    [loading, data, scope_id],
  )
}

export const ticketProfile = {
  ticketType: backendDocType,
  namespace,
  states: [
    {
      main_state: TicketState.CREATE,
      assignee_quota: 2,
      assignee_as_editor: true,
      crud: CRUDO.RW_NO_OVERWRITE,
    },
    {
      main_state: TicketState.MERGE,
      assignee_quota: 1,
      assignee_as_editor: false,
      crud: CRUDO.FULLY_ACCESS,
    },
    {
      main_state: TicketState.FINISH,
      assignee_quota: 0,
      assignee_as_editor: false,
      crud: CRUDO.READ_ONLY,
    },
  ],
  autoCreate: true,
  enableVersion: false,
  filterByCurrentUser: true,
  fixedTickeName: true,
}
